export default function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
}



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-collection/src/values.js
// module id = ../../../../d3-collection/src/values.js
// module chunks = vendor